import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-num-blank-pages',
  templateUrl: './tooltip-info-num-blank-pages.component.html',
  standalone: false
})
export class TooltipInfoNumBlankPagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
